const Layout = () => import(/* webpackChunkName: "base" */'@/components/common/Layout');
const Ministry = () => import(/* webpackChunkName: "docking" */'@/components/pages/docking/Ministry.vue');

export default [
  {
    path: '/docking',
    name: 'docking',
    component: Layout,
    meta: {
      roles: [
        'EDUCATION_EVENT_QUERY',
      ],
      title: '对接信息',
      icon: 'docking'
    },
    children: [
      {
        path: 'ministry',
        name: 'ministry',
        meta: {
          title: '教育部事件',
          roles: ['EDUCATION_EVENT_QUERY'],
          componentName: 'Ministry',
          breadcrumb: [
            {
              name: '首页',
              path: '/home'
            },
            {
              name: '对接信息',
              path: ''
            },
            {
              name: '教育部事件',
              path: '/docking/ministry',
            }
          ]
        },
        component: Ministry,
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/docking.js